import React, { useLayoutEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { IDoubleTextNodeClampProps } from './DoubleTextNodeClamp.types';

import './DoubleTextNodeClamp.scss';

const DoubleTextNodeClamp = ({ current, previous, isChanged, lineHeight = 80 }: IDoubleTextNodeClampProps) => {
	const textRef = useRef<HTMLInputElement | null>(null);
	const [isFullTextVisible, setIsFullTextVisible] = useState(false);
	const [isFullSize, setIsFullSize] = useState(false);

	const watchValue = current || previous;

	const getDimensions = () => {
		if (textRef.current) {
			const isFullSize = textRef.current?.offsetHeight <= lineHeight;

			setIsFullSize(isFullSize);
		}
	};

	useLayoutEffect(() => {
		getDimensions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [watchValue, textRef.current]);

	const textClassName = cn({ 'f5gDoubleTextNodeClampClamped': !isFullTextVisible && !isFullSize });

	const childTextClassName = cn({
		'f5gDoubleTextNodeClampCut': !isFullTextVisible && !isFullSize,
	});

	const handleClick = () => setIsFullTextVisible(!isFullTextVisible);

	return (
		<div className='f5gDoubleTextNodeClampContainer'>
			<div
				ref={textRef}
				className={textClassName}
			>
				<span className={cn({ 'f5gDoubleTextNodeClampChangedValues': isChanged })}>
					{current &&
						<span
							className={childTextClassName}
							data-testid='current-value'
						>
								{current}&nbsp;
						</span>}
					{previous && isChanged && (
						<span
							className={cn('f5gDoubleTextNodeClampPrevious', [childTextClassName])}
							data-testid='previous-value'
						>
							{previous}
						</span>
					)}
				</span>
			</div>
			{!isFullSize &&
				<div
					className='f5gDoubleTextNodeClampToggleBtn'
					onClick={handleClick}
				>
					{isFullTextVisible ? 'Show less' : 'Show more'}
				</div>
			}
		</div>
	);
};

export default DoubleTextNodeClamp;
